export default "__VITE_ASSET__DNlb3waN__"